var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _c("div", { staticClass: "hot-list" }, [
      _c(
        "div",
        {
          staticClass: "hot-body",
          staticStyle: { "border-bottom": "1px solid #eee" }
        },
        [
          _c(
            "div",
            { staticClass: "flex-row", staticStyle: { color: "#767676" } },
            [
              _c("span", [
                _c("i", {
                  staticClass: "iconfont icon-collection",
                  staticStyle: { "vertical-align": "middle", color: "#484848" }
                }),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("recent_search")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "hover-class", on: { click: _vm.clearRecord } },
                [_vm._v(_vm._s(_vm.$t("clear_record")))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-row-wrap" },
            _vm._l(_vm.$store.getters.historyCityList, function(item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "city-tag",
                  on: {
                    click: function($event) {
                      _vm.select(item)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      item.hotelName ||
                        item.areaName ||
                        item.cityName ||
                        item.city_name ||
                        item.name
                    )
                  )
                ]
              )
            })
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "hot-body" }, [
        _c(
          "div",
          { staticClass: "flex-row", staticStyle: { color: "#767676" } },
          [
            _c("span", [
              _c("i", {
                staticClass: "iconfont icon-recommend",
                staticStyle: { "vertical-align": "middle", color: "#484848" }
              }),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("hot_rec")) +
                  "\n                "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-row-wrap" },
          _vm._l(_vm.$store.getters.hotList, function(item, i) {
            return _c(
              "span",
              {
                key: i,
                staticClass: "city-text",
                on: {
                  click: function($event) {
                    _vm.select(item)
                  }
                }
              },
              [_vm._v(_vm._s(item.city_name))]
            )
          })
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f41df1ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f41df1ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/HotCItyList.vue
// module id = null
// module chunks = 